import { AdsAdminForm } from "./ads-admin-form";
import { AdsAdminHandler } from "./ads-admin-handler";
import { AdsAdminListener } from "./ads-admin-listener";

export class AdsAdminSetup {
    public form: AdsAdminForm;

    public handler: AdsAdminHandler;

    public listener: AdsAdminListener;

    public constructor(root: HTMLElement) {
        this.form = new AdsAdminForm(root);
        this.handler = new AdsAdminHandler(this.form);
        this.listener = new AdsAdminListener(this.form, this.handler);
    }

    public init(): void {
        if (this.form.isInitialized()) {
            return;
        }

        this.listener.register();
        this.form.markInitialized();
    }

    public static init(scope: ParentNode = document): void {
        const root = scope instanceof HTMLElement || scope instanceof Document ? scope : document;
        const targets: HTMLElement[] = [];

        if (root instanceof HTMLElement && root.matches(".ads-admin")) {
            targets.push(root);
        }

        AdsAdminForm.getRoots(root).forEach((node) => {
            if (node instanceof HTMLElement) {
                targets.push(node);
            }
        });

        for (const target of targets) {
            const setup = new AdsAdminSetup(target);
            setup.init();
        }
    }
}
